<script setup>
import { onMounted, onUnmounted } from 'vue';
import AMapLoader from '@amap/amap-jsapi-loader';

let map = null;

onMounted(() => {
    AMapLoader.load({
        key: '1fe9d4385e8da900a98fb1f3f431bce0', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.PlaceSearch', 'AMap.Geolocation'] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
    })
        .then(AMap => {
            map = new AMap.Map('container', {
                // 设置地图容器id
                viewMode: '3D', // 是否为3D地图模式
                zoom: 14, // 初始化地图级别
                center: [104.062243, 30.624676] // 初始化地图中心点位置
            });
            AMap.plugin(
                [
                    'AMap.PlaceSearch',
                    'AMap.ToolBar',
                    'AMap.Scale',
                    'AMap.HawkEye',
                    'AMap.Geolocation',
                    'AMap.MapType',
                    'AMap.MouseTool'
                ],
                function () {
                    //异步同时加载多个插件
                    // 添加地图插件
                    // map.addControl(new AMap.PlaceSearch());
                    map.addControl(new AMap.ToolBar()); // 工具条控件;范围选择控件
                    map.addControl(new AMap.Scale()); // 显示当前地图中心的比例尺
                    map.addControl(new AMap.HawkEye()); // 显示缩略图
                    map.addControl(new AMap.Geolocation()); // 定位当前位置
                    map.addControl(new AMap.MapType()); // 实现默认图层与卫星图,实时交通图层之间切换

                    // 以下是鼠标工具插件
                    const mouseTool = new AMap.MouseTool(map);
                    // mouseTool.rule();// 用户手动绘制折线图,测量距离
                    // mouseTool.measureArea(); // 测量面积
                }
            );
            var marker = new AMap.Marker({
                position: new AMap.LngLat(104.062243, 30.624676), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                title: '四川省医疗卫生服务指导中心'
            });
            map.add(marker);
            marker.on('click', e => {
                let content = [
                    // e.pos[0],e.pos[1],
                    `<div style='\'padding:0px' 0px = '' 4px; \'=''><b>四川省医疗卫生服务指导中心</b>`,
                    '电话 : 028-86136576   邮编 : 610000',
                    '地址 :成都市武侯区玉林南街2号附3号(倪家桥地铁站E口步行170米)</div></div>'
                ];
                let infoWindow = new AMap.InfoWindow({
                    anchor: 'top-left',
                    content: content.join('<br>') //传入 dom 对象，或者 html 字符串
                });
                // 打开信息窗体
                let dd = map.getCenter();
                // dd.pos = [e.pos[0], e.pos[1]]
                dd.lat = 30.624676;
                dd.lng = 104.062243;
                infoWindow.open(map, dd);
            });
        })
        .catch(e => {
            console.log(e);
        });
});

onUnmounted(() => {
    map?.destroy();
});
</script>

<template>
    <div id="container"></div>
</template>

<style scoped>
#container {
    width: 100%;
    height: 60%;
}
@media screen and (max-width: 750px) {
    #container {
        height: 30%;
    }
}
</style>
